import { getEmployeeTableColumns } from "../../utils/getEmployeeTableColumns";
import ellipsisImage from "../../../../common/images/ellipsis.svg";
import { CertificateStatusEnum } from "../../../../common/enums/CertificateStatusEnum";
import {
    QualificationDetailPageInterface,
    setStatus,
} from "../../QualificationDetailSlice";
import {
    setIsCreateCertificateModalOpen,
    setSelectedQualification,
} from "../../../../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { TertiaryTable } from "@hatch-digital-nl/abs-storybook/legacy";
import { QualificationInterface } from "../../../../common/interfaces/QualificationInterface";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { mapCertificateDataToRows } from "../../utils/mapCertificateDataToRows";
import { CertificateInterface } from "../../../../common/interfaces/CertificateInterface";
import { JSX } from "react";
import Skeleton from "react-loading-skeleton";
import { MetaInterface } from "../../../../common/interfaces/MetaInterface";

interface AchievedCertificatesProps {
    certificates?: {
        data?: CertificateInterface[];
        meta?: MetaInterface;
    };
    qualificationData?: QualificationInterface;
    certificateIsLoading: boolean;
    certificateIsFetching: boolean;
    qualificationIsLoading: boolean;
    totals: {
        totalActive?: number;
        totalExpired?: number;
    };
}

export const AchievedCertificates = (
    props: AchievedCertificatesProps,
): JSX.Element => {
    const {
        certificates,
        qualificationData,
        certificateIsLoading,
        certificateIsFetching,
        qualificationIsLoading,
        totals,
    } = props;
    const qualificationDetail = useAppSelector(
        (state) => state.qualificationDetail,
    ) as QualificationDetailPageInterface;
    const dispatch = useAppDispatch();

    if (
        !certificates ||
        !certificates.data ||
        !certificates.meta ||
        !qualificationData ||
        certificateIsLoading ||
        certificateIsFetching ||
        qualificationIsLoading
    ) {
        return <Skeleton count={6} height={"5rem"} borderRadius={"0.8rem"} />;
    }

    return (
        <TertiaryTable
            data={{
                columns: getEmployeeTableColumns({
                    sortAchievedCertificates:
                        qualificationDetail.sortAchievedCertificates,
                    dispatch,
                }),
                rows: mapCertificateDataToRows(certificates.data),
                total: certificates.meta.total,
            }}
            IconButtonIconUrl={ellipsisImage}
            IconButtonBackgroundColor={"#F3F4F6"}
            checkboxes={false}
            isDataEmpty={certificates.data.length === 0}
            title={`Behaald door medewerkers (${certificates.meta?.total || 0})`}
            emptyResultText={
                "Jouw vestiging en medewerkers hebben dit certificaat nog <span>niet</span> behaald."
            }
            totalActiveRecords={totals?.totalActive}
            totalExpiredRecords={totals?.totalExpired}
            currentStatus={
                qualificationDetail.status
                    ? qualificationDetail.status
                    : CertificateStatusEnum.ACTIVE
            }
            onStatusClick={(newStatus: string) =>
                dispatch(setStatus(newStatus))
            }
            onAddCertificateClick={() => {
                dispatch(setIsCreateCertificateModalOpen(true));
                dispatch(setSelectedQualification(qualificationData));
            }}
            isBackgroundTransparent={true}
        />
    );
};
